export default __webpack_public_path__ + "static/media/Programming-rafiki.dbc6b9ed.svg";